module.exports = __webpack_public_path__ + "static/media/Delivery.8b11252f.svg";